export const testimonials = [
  {
    name: "@一颗看热闹的栗子",
    role: "热搜深潜型网友",
    text: "以前刷到瓜只能看个热闹，补前情要翻半小时。这里把时间线理得明明白白，我这种零基础选手三分钟就上车了。",
    tag: "补课体验",
  },
  {
    name: "@今晚也在嗑糖",
    role: "综艺剧集双修用户",
    text: "最戳我的是它把网友分歧也列出来了，还标了各派占比。看完终于知道评论区为什么吵，也终于敢发表自己的看法了。",
    tag: "立场地图",
  },
  {
    name: "@熬夜冠军小王",
    role: "音乐节老炮儿",
    text: "抢票风波那期我真的全程代入，它连主办方公告和退单截图该往哪看都写清楚了。不是那种只说‘你猜’的瓜站。",
    tag: "实操指南",
  },
];

export const coreValues = [
  { icon: "ri-scales-3-line", title: "克制中立", desc: "把多方说法摆清楚，不靠标题煽动情绪，把判断空间留给读者。" },
  { icon: "ri-focus-3-line", title: "追根溯源", desc: "每条线索尽量回到第一手信源，写清是确认信息还是待核传闻。" },
  { icon: "ri-time-line", title: "尊重前情", desc: "坚持时间线叙事，让没跟上的人也能快速补课，而不是空降结论。" },
  { icon: "ri-user-heart-line", title: "友好进圈", desc: "对新手友好、对争议克制，让吃瓜这件事本身更轻松、更健康。" },
];

export const contentPrinciples = [
  "以时间线为准绳，避免断章取义地截取片段下结论。",
  "信源分级呈现，标注确认信息与待核实传闻，不把推测当事实。",
  "展示多方立场与各自依据，反对单方面的情绪审判。",
  "尊重当事人与围观者的边界，不传播未经证实的隐私信息。",
  "复盘类内容明确标注为观点，与瓜单的中立定位分开。",
];

export const aboutMilestones = [
  { year: "起点", text: "创始人发现大瓜‘散’是最大痛点：热度最高时信息最乱，想认真吃瓜反而没地方去。" },
  { year: "现在", text: "从一个整理热搜的表格，长成把时间线、必看线索与多方分歧都归档的吃瓜指南站。" },
  { year: "未来", text: "希望成为吃瓜群众进圈的第一站：先在这里看懂前情，再去各大平台开心开吃。" },
];